import { createContext } from "react";

const stateContext = createContext(null);

export default stateContext;